<template>
  <Breadcrumb
    :items="breadcrumbItems"
    v-if="!props.acaoId"
  />

  <FiltrosComponent
    :isCoordenador="isCoordenador"
    :nomeTela="'noticia'"
    @pesquisar="onPesquisar"
  />

  <Carregamento v-if="isLoading" />

  <div
    id="noticias"
    v-else
  >
    <div
      class="lista"
      v-for="noticia in noticias"
      :key="noticia.id"
    >
      <NoticiasCard :noticia="noticia" />
    </div>

    <!-- Mensagem quando não há notícias -->
    <AvisoListagem v-if="noticias.length === 0 && !isLoading">
      Nenhuma notícia encontrada.
    </AvisoListagem>
  </div>

  <PaginacaoComponent
    v-if="!isLoading"
    :total-paginas="totalPages"
    @mudar-pagina="carregarPagina"
  />
</template>

<script>
export default { name: "MenuNoticiasView" };
</script>
<script setup>
import { watch, computed } from "vue";
import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import { useRouter, useRoute } from "vue-router";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import NoticiasCard from "@/components/noticias/NoticiasCard.vue";
import AvisoListagem from "@/components/common/AvisoListagem.vue";
import { useNoticias } from "@/composables/useNoticias";

const router = useRouter();
const route = useRoute();

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Notícias", to: "/noticias" },
  ];
});

const { noticias, isLoading, fetchFiltrosNoticia, totalPages } = useNoticias();

const props = defineProps({
  isAtiva: Boolean,
  isCoordenador: {
    type: Boolean,
    default: false,
  },
  acaoId: String,
});

watch(
  () => route.query,
  (newQuery) => {
    const termo = newQuery.q || "";
    const dataInicial = newQuery.dataInicial || "";
    const dataFinal = newQuery.dataFinal || "";
    const unidadeId = newQuery.unidadeId || null;
    const pagina = Number(newQuery.page) || 0;

    fetchFiltrosNoticia({
      page: pagina,
      size: 5,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      unidadeId: unidadeId,
      titulo: termo,
      acaoId: props?.acaoId,
    });
  },
  { immediate: true }
);

function carregarPagina(pagina) {
  const query = { ...route.query };
  if (pagina > 0) {
    query.page = pagina;
  } else {
    delete query.page;
  }

  router.push({ query });
}

function onPesquisar(termo) {
  const query = { ...route.query };
  if (termo && termo.trim()) {
    query.q = termo.trim();
  } else {
    delete query.q;
  }
  delete query.page;

  router.push({ query });
}
</script>

<style scoped>
.lista {
  width: 100%;
  max-height: 216px;
  margin-bottom: 1rem;
}
</style>
